import React from 'react';

function ContentPageSlides({
  slide,
  currentSlide,
  slideCount,
  isLastSlide,
  onPrev,
  onNext,
  submittedAnswers,
  setSubmittedAnswers,
  selectedOption,
  setSelectedOption,
}) {
  const isExercise = slide.exercise && slide.exercise.length > 0;
  const submission = submittedAnswers[currentSlide];
  const submitted = submission !== null;

  const handleOptionClick = (idx, isCorrect) => {
    if (submitted && submission.isCorrect) {
      return; // Don't allow changing a correct answer
    }
    setSelectedOption(idx);
    const updatedAnswers = [...submittedAnswers];
    updatedAnswers[currentSlide] = { index: idx, isCorrect: isCorrect };
    setSubmittedAnswers(updatedAnswers);
  };

  return (
    <div style={{ margin: '32px 0', flex: 1 }}>
      <div id="slide_text" style={{ fontWeight: 'bold', fontSize: '22px', marginBottom: '16px' }}>
        {slide.heading}
      </div>
      {slide.paragraph && (
        <p id="slide_text" style={{ fontSize: '18px', margin: '16px 0' }}>
          {slide.paragraph}
        </p>
      )}
      {slide.bullets?.length > 0 && (
        <ul>
          {slide.bullets.map((item, i) => (
            <li id="slide_text" key={i} style={{ fontSize: '17px', marginBottom: '10px' }}>{item}</li>
          ))}
        </ul>
      )}
      {slide.image && (
        <div style={{ textAlign: 'center' }}>
          <img src={slide.image} alt="" style={{ maxWidth: "100%", maxHeight: "200px", margin: "16px 0" }} />
        </div>
      )}
      {isExercise && (
        <div style={{ margin: '24px 0' }}>
          {slide.exercise.map((option, idx) => {
            const isCorrect = option.endsWith('*');
            const displayOption = option.replace('*', '');
            const isSelected = selectedOption === idx;
            const isSubmittedAndCorrect = submitted && submission.isCorrect && submission.index === idx;

            let feedback = null;
            if (submitted && submission.index === idx) {
              feedback = submission.isCorrect
                ? <span className="c3-feedback c3-feedback-correct">Correct!</span>
                : <span className="c3-feedback c3-feedback-wrong">Wrong, try again!</span>;
            }

            return (
              <div
                key={idx}
                id="slide_text"
                className={
                  `c3-exercise-option` +
                  (isSelected ? ' selected' : '') +
                  (isSubmittedAndCorrect ? ' locked' : '')
                }
                onClick={() => handleOptionClick(idx, isCorrect)}
              >
                {displayOption}
                {feedback}
              </div>
            );
          })}
        </div>
      )}
      {/* Navigation buttons */}
      <div className="nav-buttons-container">
        <button
          className="nav-button nav-button-prev"
          onClick={onPrev}
          onMouseUp={e => e.currentTarget.blur()}
          disabled={currentSlide === 0}
        >
          Previous
        </button>
        <button
          className="nav-button nav-button-next"
          onClick={onNext}
          onMouseUp={e => e.currentTarget.blur()}
          disabled={isLastSlide}
        >
          Next
        </button>
      </div>
    </div>
  );
}

export default ContentPageSlides;